module.exports = {
	"title": {
		"artist": "Ecoutez {artistName} sur Qobuz",
		"album": "Ecoutez l'album {albumName} de {artistName} sur Qobuz",
		"track": "Ecoutez {trackName} de {artistName} sur Qobuz",
		"playlist": "Ecoutez la playlist {playlistName} de {ownerName} sur Qobuz",
		"focus": "Lisez ce Grand Angle sur Qobuz"
	},
	"buttons": {
		"listen": "Ecouter sur Qobuz",
		"buy": "Acheter sur la boutique",
		"download": "Télécharger Qobuz pour Mac/PC",
		"readmore": "Lire la suite",
		"showless": "Afficher moins",
		"showmore": "Voir plus",
		"readfocus": "Lire ce Grand Angle sur Qobuz",
		"seeSubscribes": "Voir les offres d'abonnements"
	},
	"infos": {
		"trackCount": "{count} pistes",
		"diskCount": "{count} disques",
		"duration": {
			"long": "{hours}h {minutes}m",
			"short": "{minutes}m {seconds}s"
		},
		"playlist": {
			"private": "Privée",
			"public": "Publique"
		},
		"hires": "Haute qualité"
	},
	"share": {
		"twitter": {
			"track": "Ecoutez {title} par {artist} sur Qobuz",
			"album": "Ecoutez {title} par {artist} sur Qobuz",
			"artist": "Ecoutez  {artist} sur Qobuz",
			"playlist": "Ecoutez {playlist} par {owner} sur Qobuz",
			"focus": "Lisez ce Grand Angle sur Qobuz"
		},
		"mail": {
			"track": {
				"subject": "{title} par {artist} est disponible sur Qobuz !",
				"body": "Ecoute {title} de {artist} avec Qobuz en haute qualité : {url}\n\nQobuz est le premier service d'écoute et de téléchargement de musique en haute qualité.\nPlus d'informations et inscription sur Qobuz.com\n\n"
			},
			"album": {
				"subject": "{title} par {artist} est disponible sur Qobuz !",
				"body": "Ecoute {title} de {artist} avec Qobuz en haute qualité : {url}\n\nQobuz est le premier service d'écoute et de téléchargement de musique en haute qualité.\nPlus d'informations et inscription sur Qobuz.com\n\n"
			},
			"artist": {
				"subject": "{artist} est sur Qobuz !",
				"body": "Ecoute {artist} avec Qobuz en haute qualité : {url}\n\nQobuz est le premier service d'écoute et de téléchargement de musique en haute qualité.\nPlus d'informations et inscription sur Qobuz.com\n\n"
			},
			"playlist": {
				"subject": "{playlist} par {owner} est disponible sur Qobuz !",
				"body": "Ecoute {playlist} de {owner} avec Qobuz en haute qualité : {url}\n\nQobuz est le premier service d'écoute et de téléchargement de musique en haute qualité.\nPlus d'informations et inscription sur Qobuz.com\n\n"
			},
			"focus": {
				"subject": "{title}",
				"body": "À lire {url}\n\nQobuz est le premier service d'écoute et de téléchargement de musique en haute qualité.\nPlus d'informations et inscription sur Qobuz.com\n\n"
			}
		}
	},
	"tracklist": {
		"title": {
			"track": "Piste",
			"album": "Titres de l'album",
			"artist": "Les meilleurs titres",
			"artist_albums": "Albums",
			"playlist": "Titres de la playlist"
		},
		"header": {
			"number": "#",
			"name": "Titre",
			"album": "Album",
			"artist": "Artiste",
			"time": "Durée",
			"label": "Label"
		},
		"media_count": "CD {mediaNumber}",
		"noTracks": "Aucune piste disponible"
	},
	"focus": {
		"from": "Par {author}",
		"albumOverlay": " - {releaseYear} - {genre}"
	},
	"playlist": {
		"from": "Par {author}"
	},
	"notifications": {
		"subscribe": "Vous devez vous abonner à l'une des offres d'écoute illimitée de Qobuz",
		"purchase": "Vous pouvez acheter cette piste pour l'écouter et l'importer dans votre application"
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/locales/fr.json
// module id = 450
// module chunks = 0